<script setup lang="ts">
// PROPS
import type { RouteLocationRaw } from '#vue-router';

defineProps({
    message: { type: String, default: undefined },
    to: { type: String as PropType<RouteLocationRaw>, default: undefined },
    iconName: { type: String, required: true },
    iconClass: { type: String, required: true },
});
</script>

<template>
    <p v-if="message || $slots.default" class="flex items-center justify-start gap-2 text-xs lg:text-sm">
        <UIcon :name="iconName" class="text-primary shrink-0 text-base" :class="iconClass" />
        <NuxtLink v-if="!!to" :to="to" class="underline" target="_blank">
            <slot :message="message">
                <span class="text-dimmed">
                    {{ message }}
                </span>
            </slot>
        </NuxtLink>

        <template v-else>
            <slot :message="message">
                <span class="text-dimmed">
                    {{ message }}
                </span>
            </slot>
        </template>
    </p>
</template>
